module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAoBAMAAABHtxQFAAAAAXNSR0IArs4c6QAAAB5QTFRFAAAAkpKSeXl5dHR0cXF0cHB0b290cHBzcHB0b29z5a8DKQAAAAl0Uk5TAAcVFpG209TYryQOJQAAAEdJREFUOMtjYIADIwacgLlMAaec+cwknNoqZ07BrW1mIG5tUwVGtdFeG3bQANJGlhw+M/G6BZ8fRjXSSuMUcvI03rIAswwBAOu1dGtNf58LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/com/left_gray_arrow.png
// module id = Dp2+
// module chunks = 24